module.exports = new __parcel__URL__("requests-resolved.11ae9621.svg").toString();